import { Component, Input } from '@angular/core';
import { IPoi, POI_KIND_META, primaryPoiKind } from '@cnt-workspace/data-access';
import { CntSymbolDirective } from '../symbols/cnt-symbol.directive';
import { ITripStopBadge } from '../map-pins';

/** A POI pin drawn exactly like the map's (`poiPinIcon` in `map-pins.ts`),
 *  with an optional trip stop badge. Used by the trip planner lists on the
 *  focused planner and the /search planner drawer. */
@Component({
  selector: 'cnt-poi-pin',
  standalone: true,
  imports: [CntSymbolDirective],
  template: `
    <span aria-hidden="true" class="relative inline-flex">
      @if (poi; as p) {
        <span
          class="w-7 h-7 rounded-lg border-2 border-white shadow-md inline-flex items-center justify-center text-white"
          [style.background]="poiColor(p)"
        >
          <span class="material-symbols-outlined text-base" style="font-variation-settings: 'FILL' 1" [cntSymbol]="poiIcon(p)"></span>
        </span>
      }
      @if (badge; as b) {
        <span
          class="absolute -top-2 -right-2 w-[18px] h-[18px] rounded-full border-2 border-white text-white text-[10px] font-bold leading-none inline-flex items-center justify-center"
          [style.background]="b.color"
        >
          @if (b.icon) {
            <span class="material-symbols-outlined text-[11px]" style="font-variation-settings: 'FILL' 1">{{ b.icon }}</span>
          } @else {
            {{ b.text }}
          }
        </span>
      }
    </span>
  `,
})
export class PoiPinComponent {
  @Input() poi: IPoi | null = null;
  @Input() badge: ITripStopBadge | null = null;

  poiColor(p: IPoi): string {
    return POI_KIND_META[primaryPoiKind(p)].color;
  }
  poiIcon(p: IPoi): string {
    return POI_KIND_META[primaryPoiKind(p)].icon;
  }
}
